import { Directive, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { EnvConfig, FeatureFlag } from '@digilize/shared/definitions/src';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens/src';

@Directive({
  selector: '[featureFlag]',
  standalone: false,
})
export class FeatureFlagDirective {
  private flag: FeatureFlag;
  private elseTemplateRef: TemplateRef<unknown> | null = null;
  private hasView = false;
  private hasElseView = false;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    @Inject(ENV_CONFIG) private envConfig: EnvConfig
  ) {}

  @Input() set featureFlag(flag: FeatureFlag) {
    this.flag = flag;
    this.updateView();
  }

  @Input() set featureFlagElse(templateRef: TemplateRef<unknown> | null) {
    this.elseTemplateRef = templateRef;
    this.updateView();
  }

  private updateView(): void {
    const enabled = this.envConfig.featureFlags[this.flag] ?? false;

    if (enabled && !this.hasView) {
      this.viewContainer.clear();
      this.hasElseView = false;
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!enabled && !this.hasElseView) {
      this.viewContainer.clear();
      this.hasView = false;
      if (this.elseTemplateRef) {
        this.viewContainer.createEmbeddedView(this.elseTemplateRef);
      }
      this.hasElseView = true;
    }
  }
}
